import { DateTime } from "luxon";
export default {
  methods: {
    goBack() {
      this.$router.push({
        name: "store",
        params: {
          storename: this.currentStoreDoc.Name,
          storeid: this.currentStoreDoc.ID,
        },
      });
    },
    getStyle() {
      var styles = [];
      if (this.showNewUi) {
        return styles;
      }
      styles.push(this.mobileStyles.primaryBackgroundColour);
      return styles;
    },
    getCreateDate(order) {
      if (order.CreatedOn)
        return DateTime.fromJSDate(
          new Date(order.CreatedOn.seconds * 1000)
        ).toFormat("ff");
    },
  },
};
